import {createContext} from 'react';
import {ToastAdd} from './Toast.model';

export const ToastContext = createContext<ToastAdd>(() => {});
